export const SHOW = 'contextMenu.show';
export const HIDE = 'contextMenu.hide';

/**
 * Zobrazení kontextového menu.
 * @param component komponenta pro zobrazení menu
 * @param componentProps vstupní props komponenty
 * @param JS event na kontext menu
 * @param customHide pokud je true, tak se při kliknutí na cokoli pod menu menu samo nezavře a musí ho zavřít někdo zvenčí (např. pro menu s checkbxama)
 * @return {{type: string, component: *, componentProps: *, position: *}}
 */
export function show(component, componentProps, event, customHide = false) {
    event.stopPropagation();
    event.preventDefault();

    return {
        type: SHOW,
        component,
        componentProps,
        customHide,
        position: {
            x: event.clientX,
            y: event.clientY
        }
    }
}

export function hide() {
    return (dispatch, getState) => {
        const state = getState().contextMenu;
        if (state.visible) {
            dispatch({
                type: HIDE
            });
        }
    }
}
